module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a8-6-1f1dc17274d738fa6d7008347a1305a4.jpg";